module.exports = __webpack_public_path__ + "static/media/mac.28fd61de.png";